import { Module } from '../../ts/Module';
import { ISiteSettingsForBridgeScope, SiteSettingsForBridgeFormCtrl } from '../controllers/SiteSettingsForBridgeFormCtrl';

Module.instance().directive('tbSiteSettingsForBridgeForm',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '^?tbSettingsCoordinator',
      templateUrl: 'siteSettingsForBridgeForm.html',
      link: ($scope: ISiteSettingsForBridgeScope,
        elm: JQuery,
        attrs: ng.IAttributes) => {
        $scope.sharedForm = $scope.sharedForm;
        $scope.sharedForm.registerFormStateByName($scope.localForm, 'siteSettingsForBridgeForm');

      },
      controller: SiteSettingsForBridgeFormCtrl
    };
  }
);
